// extracted by mini-css-extract-plugin
export default {"thead":"Table_thead__RAzrt","tbody":"Table_tbody__xILkV"};